import styled, { css } from 'styled-components';
import { fontTitle, fontBody } from 'Styles/fonts';
import { convertColorToThemeHexCode } from 'Styles/colors.util';
import strikethrough from 'Styles/strikethrough';

export const Input = styled.input`
  opacity: 0;
  position: absolute;
  left: -9999px;
`;

export const Span = styled.span`
  ${fontTitle(16)};
  align-self: center;
  border-radius: var(--radius-tile);
  border: 2px solid transparent;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  min-width: 56px;
  padding: 7px 4px 8px 4px;
  text-align: center;
  text-transform: none;
  transition: border-color 200ms cubic-bezier(0, 0.5, 0.1, 1);
  user-select: none;
  width: 100%;
`;

export const Label = styled.label`
  display: flex;
  flex: 1;
  justify-content: center;
  border-radius: var(--radius-tile);
  background-color: var(--muted-background);
  color: var(--muted-foreground);
  box-shadow: var(--shadow-inner);

  @media (hover: hover) {
    ${Input}:hover:not(:checked):not([disabled]) ~ ${Span} {
      color: var(--foreground);
      border-color: var(--border);
    }
  }

  ${Input}:checked ~ ${Span} {
    color: var(--foreground);
    border-color: var(--ring);
  }

  ${Input}:focus-visible ~ ${Span} {
    outline: none;
    border-color: var(--focus);
  }

  ${Input}[disabled] ~ ${Span} {
    cursor: not-allowed;
  }

  ${({ isUnavailable, isSelected }) => {
    if (isUnavailable && isSelected)
      return css`
        background-image: ${strikethrough(
          convertColorToThemeHexCode('black'),
          2
        )};
      `;

    if (isUnavailable)
      return css`
        background-image: ${strikethrough(
          convertColorToThemeHexCode('grey60'),
          2
        )};
        &:hover {
          background-image: ${strikethrough(
            convertColorToThemeHexCode('black'),
            2
          )};
        }
      `;
  }}
`;

export const Note = styled.span`
  display: block;
  text-transform: none;
  ${fontBody(14)}
`;
